import axios from 'axios'
import store from '@/store'

// create an axios instance
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API,
    baseURL: "https://www.mayuanfei.com/webapi/",
    timeout: 5000, // request timeout

})

// request interceptor
service.interceptors.request.use(
    config => {
        console.log(config)
        if(config.method=="get"){
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
        }
        // do something before request is sent

        // if (store.getters.token) {
        //     config.headers['X-Token'] = getToken()
        // }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // store.commit('SET_LOADING',false);
        // if the custom code is not 20000, it is judged as an error.
        if (res.code != 0) {
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
        // if (res.code !== 20000) {
        //     return Promise.reject(new Error(res.message || 'Error'))
        // } else {
        //     return res
        // }
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

export default service
